<template>
  <div class="ui-content dashboard">
    <div v-if="!purchasedTest">
    <UpgradeTestModal :data="popUpMessage" />
    </div>
    <v-card v-if="purchasedTest" class="mx-auto normal-card autohg indcard">
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:body="{ items }">
            <tbody class="inst-data-body">
              <tr v-for="item in items" :key="item.name">
                <td class="int-1201">{{ item.test_name }}</td>
                <td class="test-list-instructions">
                  <div class="inst-data">
                    <span class="instructions-data">{{
                      extractContent(item.instructions)
                    }}</span>
                    <v-icon class="exe-icon" @click="TestInfoDialog(item)"
                      >mdi-alert-circle</v-icon
                    >
                  </div>
                </td>
                <td class="int-120-t">{{ item.target_name }}</td>
                <td class="duration-display">{{ item.duration }}</td>
                <td class="preview-scroll-schedule">
                  <div
                    class="Schedule int-120"
                    @click="ScheduleTestDialog(item)"
                  >
                    Schedule
                  </div>
                </td>
                <td class="preview-scroll">
                  <div class="cursor_click" @click="onPreviewClick(item)">
                    Preview
                  </div>
                </td>
                <td>
                  <v-btn
                    class="download-btn-cp3"
                    color="transparent"
                    @click="downloadTest(item)"
                    depressed
                  >
                    <v-img
                      width="23px"
                      src="../../../assets/img/download.svg"
                    ></v-img>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="{ selectedTest }"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UpgradeTestModal from "./UpgradeTestModal.vue";
export default {
    name: "ChapterTest",
    props: ["parentId", "subType", "purchasedTest", "search"],
    data() {
        return {
            loading: false,
            testName: null,
            orderBy: {
                field: "test_name",
                order: "ASC",
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            headers: [
                { text: "Test Name", value: "test_name", class: "int-1201" },
                {
                    text: "Test Instructions",
                    value: "instructions",
                    hideSort: true,
                    class: "test-list-instructions",
                },
                { text: "Target", value: "target_name", class: "int-120-t" },
                {
                    text: "Duration\n(Mins)",
                    value: "duration",
                    class: "duration-display",
                    hideSort: true,
                },
                { text: "", value: "", type: "blank", class: "preview-scroll-schedule" },
                { text: "", value: "", type: "blank", class: "preview-scroll" },
                { text: "", value: "", type: "blank", class: "int-120" },
            ],
            typetimeout: 0,
            items: [],
            dialog: false,
            cComponent: "components/coordinator/Tests/ScheduleTestPopup",
            status: false,
            selectedTest: null,
            modalwidth: "1000px",
            popUpMessage: "You do not have acess to these tests."
        };
    },
    mounted() {
        this.defaultData();
    },
    computed: {
        ...mapState("userStore", ["user"]),
    },
    methods: {
        ...mapActions({
            getTestList: "testStore/getTestList",
            me: "userStore/me",
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.testName = crd.searchText ? crd.searchText : null;
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
            }
            // this.updateRouteDetails({isViewed: false});
            this.requestGetTestList();
        },
        onClose(data) {
            this.status = data.status;
        },
        resetFields() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.totalPages = 1;
        },
        updateRouteDetails(updatedDetails) {
            let routeName = this.$route.name;
            updatedDetails.routeName = routeName;
            this.setRouteDetails(updatedDetails);
        },
        onPreviewClick(test) {
          localStorage.setItem("previousPath", this.$route.path);
            this.$router.push({
                name: "instructions-about-test",
                params: {
                    test_id: test.id,
                    test_institute_id: test.test_institute_id,
                },
            });
        },
        requestGetTestList() {
            let reqData = {
                test_types: [parseInt(this.parentId)],
                test_sub_types: [parseInt(this.subType)],
                orderBy: this.orderBy,
                test_name: this.search,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
            };
            this.$root.showLoader = true;
            this.getTestList(reqData)
                .then((response) => {
                if (response.list.length == 0 &&
                    this.currentPage != 1 &&
                    !this.$route.query.resetPage) {
                    this.onPageChange(1);
                }
                this.$root.showLoader = false;
                this.items = response.list;
                this.totalPages = response.pagination.pageCount;
            })
                .catch((err) => {
                this.loading = false;
                this.$root.showLoader = false;
            });
        },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
            }
        },
        onSortChange() {
            this.requestGetTestList();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetTestList();
        },
        ScheduleTestDialog(item) {
            if (this.user.institute_type == this.types.SILVER &&
                this.parentId == this.TEST_TYPE.ALL_INDIA_TEST) {
                this.cComponent = "components/common/NotGoldMessage";
                this.modalwidth = "500px";
            }
            else {
                this.selectedTest = item;
                this.cComponent = "components/coordinator/Tests/ScheduleTestPopup";
                this.modalwidth = "1000px";
            }
            this.status = true;
        },
        TestInfoDialog(item) {
            this.selectedTest = item;
            this.cComponent = "components/coordinator/Tests/InstructionsPopup";
            this.modalwidth = "600px";
            this.status = true;
        },
        downloadTest(item) {
            let domainUrl = process.env.VUE_APP_API_URL;
            let token = sessionStorage.getItem("auth_token");
            let url = domainUrl + `/test/download-test/${item.id}?token=${token}`;
            //   alert(url);
            window.open(url, "_blank");
        },
    },
    watch: {
        search() {
            this.requestGetTestList();
        },
    },
    components: { UpgradeTestModal }
};
</script>
